/*
 * nadi-menu.js — the desktop dropdowns, sized and furnished.
 *
 * WHY THIS EXISTS. Measured on the live site at 1440x900, with every dropdown
 * forced open: "לכל המותגים" holds 30 links in one 250px column, which makes
 * the panel 1,280px tall and puts its bottom 577px BELOW the fold, with
 * overflow:visible and max-height:none. Those brands are simply unreachable
 * with a mouse. "ציוד למספרות" is 608px and only just fits. Nadav found this
 * before I fixed it, which is the right order of events but the wrong way
 * round.
 *
 * WHY JAVASCRIPT AND NOT CSS. Column count has to follow the number of links,
 * and CSS cannot count children. `column-width` gets close but derives the
 * count from the panel's width, which is the thing we are trying to decide.
 * And the panel hangs off its menu item, so a wide panel on a left-hand item
 * runs off the page: that needs a measure-then-correct pass, which is JS by
 * definition. So JS decides width and position; CSS does every bit of the
 * look.
 *
 * NOTHING HERE TOUCHES A KALLES FILE. The panels are Kalles markup, but we
 * only add a class, a CSS variable and one promo card. Below 1025px this does
 * not run at all — Kalles serves the drawer there, and that is 95% of this
 * store's traffic.
 */
(function () {
  'use strict';

  var MIN_WIDTH = 1025;
  var COL = 232;   /* one column of links */
  var GAP = 30;
  var PAD = 64;    /* the panel's own left+right padding, see nadi-tweaks.css */
  var PROMO_W = 250;
  var EDGE = 16;   /* the smallest gap we will leave to the window edge */

  /* The one active promo, already printed on every page by
     snippets/nadi-promo-data.liquid for the cart band. Reused rather than
     duplicated: one source, so it can never say two different things. */
  var PROMO = (function () {
    try {
      var el = document.getElementById('NadiPromoData');
      if (!el) return null;
      var list = JSON.parse(el.textContent) || [];
      return list.length ? list[0] : null;
    } catch (e) { return null; }
  })();

  /* 30 brands want four columns; four deals want none. The thresholds are the
     real counts in this store's menus: 30, 14, 11, 10, 6, 4.

     They were tuned by measuring, not by taste. At a >=9 threshold the 10-item
     menus opened 1,099px wide and 233px tall — a letterbox of mostly nothing.
     Moving the third column to 13 gives those menus a 558px panel that fills
     itself. The reward is that this scales with the catalogue rather than
     against it: add a "מותגים בקטגוריה" sub-menu to the colours menu in Shopify
     Navigation and it crosses 13, earns its third column and its promo card on
     its own, with nothing changed here. */
  function columnsFor(n) {
    if (n >= 20) return 4;
    if (n >= 13) return 3;
    if (n >= 5) return 2;
    return 1;
  }

  function promoCard() {
    if (!PROMO || !PROMO.title) return null;
    var a = document.createElement('a');
    a.className = 'nadi-mm__promo';
    a.href = PROMO.url || '/collections/all';
    var k = document.createElement('span');
    k.className = 'nadi-mm__promo-kicker';
    k.textContent = 'מבצע פעיל';
    var t = document.createElement('span');
    t.className = 'nadi-mm__promo-title';
    t.textContent = PROMO.title;
    a.appendChild(k);
    a.appendChild(t);
    if (PROMO.line) {
      var l = document.createElement('span');
      l.className = 'nadi-mm__promo-line';
      l.textContent = PROMO.line;
      a.appendChild(l);
    }
    var c = document.createElement('span');
    c.className = 'nadi-mm__promo-cta';
    c.textContent = 'לדילים';
    a.appendChild(c);
    return a;
  }

  /* HOW MANY PRODUCTS ARE BEHIND EACH WORD.
     Printed by snippets/nadi-menu-meta.liquid; see its comment for why the menu
     carries counts rather than the thumbnails one would reach for first. Matched
     to a link by the collection handle in its href, which is percent-encoded
     Hebrew, so it is decoded before the lookup. A link to anything other than a
     collection, or to a collection with nothing in it, simply gets no count. */
  var COUNTS = (function () {
    try {
      var el = document.getElementById('NadiMenuMeta');
      return el ? (JSON.parse(el.textContent) || {}) : {};
    } catch (e) { return {}; }
  })();

  function addCounts(panel) {
    panel.querySelectorAll('a[href*="/collections/"]').forEach(function (a) {
      /* nadi-menu-deals.js draws its own filled pill on a pinned deals row.
         Without this guard both scripts add a number and the row reads '1818'
         — measured on the draft, 2026-10-08. Each script skips the other's
         mark, so neither depends on running first. */
      if (a.querySelector('.nadi-mm__n, .nadi-dealrow__n')) return;
      if (a.classList.contains('nadi-mm__all')) return;
      var m = a.getAttribute('href').match(/\/collections\/([^/?#]+)/);
      if (!m) return;
      var handle;
      try { handle = decodeURIComponent(m[1]); } catch (e) { handle = m[1]; }
      var n = COUNTS[handle];
      if (!n) return;
      var s = document.createElement('span');
      s.className = 'nadi-mm__n';
      s.textContent = n;
      a.appendChild(s);
    });
  }

  /* The way out of the menu. Without it the panel is a list that ends; with it
     the category itself is one click away, which is where a browsing customer
     usually wants to go. The destination is the top-level item's own link, so
     nothing here is invented. */
  function allLink(panel, li) {
    if (panel.querySelector('.nadi-mm__all')) return;
    var top = li.querySelector(':scope > a');
    if (!top || !top.getAttribute('href') || top.getAttribute('href') === '#') return;
    var row = document.createElement('a');
    row.className = 'nadi-mm__all';
    row.href = top.getAttribute('href');
    row.textContent = 'לכל הקטגוריה';
    panel.appendChild(row);
  }

  function layout(panel) {
    var list = panel.querySelector('.t4s-lazy_menu');
    if (!list) return;
    var count = list.querySelectorAll('.t4s-menu-item').length;
    if (!count) return;

    var cols = columnsFor(count);
    if (cols < 2) {                 /* a short menu is right as Kalles draws it */
      panel.classList.remove('nadi-mm');
      panel.style.removeProperty('width');
      panel.style.removeProperty('right');
      return;
    }

    var withPromo = cols >= 3 && PROMO;
    if (withPromo && !panel.querySelector('.nadi-mm__promo')) {
      var card = promoCard();
      if (card) panel.appendChild(card);
    }

    addCounts(panel);
    allLink(panel, panel.parentElement);

    panel.style.setProperty('--nadi-cols', cols);
    panel.classList.add('nadi-mm');

    var width = PAD + cols * COL + (cols - 1) * GAP + (withPromo ? PROMO_W + GAP : 0);

    /* Measure, then correct. The panel's right edge sits on its menu item's
       right edge, so a wide panel opened from a left-hand item would hang off
       the page; and after shifting it back it must still not cross the other
       edge. Both are read from the box, never assumed. */
    panel.style.removeProperty('right');
    panel.style.setProperty('width', width + 'px', 'important');
    var r = panel.getBoundingClientRect();

    if (r.left < EDGE) {
      panel.style.setProperty('right', -(EDGE - r.left) + 'px', 'important');
      r = panel.getBoundingClientRect();
    }
    var over = r.right - (window.innerWidth - EDGE);
    if (over > 0) {
      panel.style.setProperty('width', Math.max(300, width - over) + 'px', 'important');
    }

  }


  /* THE ROW ITSELF.
     Two things CSS cannot do here. An offer is not a category and should not
     look like one, but which item is an offer lives in Nadav's wording, not in
     a list kept here — so it is read from the label. And the bar is packed to
     the millimetre today (eight items, 1,290px, inside 1,290px), so a fixed gap
     would force a wrap; the gap is therefore whatever room is actually left,
     which is nothing now and about 24px the moment the labels are shortened. */
  function row() {
    var ul = document.querySelector('.t4s-nav__ul');
    if (!ul) return;
    var items = [].slice.call(ul.children);
    if (!items.length) return;

    items.forEach(function (li) {
      var a = li.querySelector(':scope > a');
      if (!a) return;
      if (/מבצע|דיל|סייל|הנחה/.test(a.textContent)) li.classList.add('nadi-nav--sale');
    });

    /* Try, then check. Computing the spare width and dividing it was the
       obvious way and it was wrong: the arithmetic said 24px would fit and the
       bar promptly wrapped onto a second line, because applying a gap changes
       the very layout the sum was taken from. So the gap is offered largest
       first and kept only if the row is still one row afterwards. */
    ul.style.removeProperty('column-gap');
    var oneRow = ul.getBoundingClientRect().height;
    for (var g = 24; g >= 4; g -= 4) {
      ul.style.setProperty('column-gap', g + 'px');
      if (ul.getBoundingClientRect().height <= oneRow) return;
      ul.style.removeProperty('column-gap');
    }
  }

  function run() {
    var wide = window.innerWidth >= MIN_WIDTH;
    if (wide) row();
    document.querySelectorAll('.t4s-type__drop > .t4s-sub-menu').forEach(function (panel) {
      if (!wide) {
        panel.classList.remove('nadi-mm');
        panel.style.removeProperty('width');
        panel.style.removeProperty('right');
        return;
      }
      layout(panel);
    });
  }

  run();


  /* The dropdowns arrive late: Kalles fetches them from
     /search?section_id=dropdown-menu on first hover and re-injects them from
     sessionStorage for half an hour after. Same answer the cart bar and the
     brand line reached — watch rather than assume, and stay idempotent. */
  if (window.MutationObserver) {
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; run(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  var t = null;
  window.addEventListener('resize', function () {
    if (t) clearTimeout(t);
    t = setTimeout(run, 150);
  });
})();
